<template>
  <div>
    <vs-popup :title="$t('Description')" :active.sync="showModal">
      <form>
        <div class="vx-row mb-4">
          <div class="vx-col w-full mt-1">
            <vs-textarea
              class="w-full p-2"
              v-model="description"
              placeholder="بدون توضیحات"
            />
          </div>
        </div>
      </form>
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <vs-button
            v-if="$props.mode === 'confirm'"
            type="filled"
            icon="done"
            class="float-right flex gap-1 px-6"
            @click.prevent="submitForm"
            >{{ $t("ConfirmOrder") }}</vs-button
          >
          <vs-button
            v-else-if="$props.mode === 'reject'"
            type="button"
            icon="clear"
            class="float-right flex gap-1 px-6 reject-btn"
            @click.prevent="submitForm"
            >{{ $t("RejectOrder") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    mode: { type: String },
    show: { default: false },
  },
  data() {
    return {
      description: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    submitForm() {
      this.$emit("submitForm", this.description);
      this.description = "";
    },
  },
  components: {},
};
</script>
